<div class="modal-share-template">
  <div class="modal-container">
    <div class="modal-title">
      <h3>
        <i class="j2-icon-cloud"></i>
        {{ 'bill.shareInvoice' | translate }}
      </h3>
      <div class="close-modal" (click)="closeModal()">
        <span class="j-icon-cross"></span>
      </div>
    </div>
    <div class="modal-body">
      <p>{{ 'bill.shareInvoice.generateLink' | translate }}</p>
      <div class="preview-block">
        <div class="preview-block-wrapper">
          <iframe *ngIf="dialogData.bill?.templateType !== 'custom'" class="document-container" id="share-bill-iframe" name="invoice-iframe" frameborder="0" scrolling="no"></iframe>
          <div class="ngx-doc-container" *ngIf="dialogData.bill?.templateType === 'custom' && dialogData.bill?.fileUrl">
            <ngx-doc-viewer
            #viewer
            [url]="dialogData.bill?.fileUrl"
            viewer="{{ docViewer }}"
            style="position: absolute;
            top: -60%;
            left: -50%;
            right: 0;
            bottom: 0px;
            transform: scalex(.5) scaleY(.5);
            width: 199.5%;
            height: 250%;"
          ></ngx-doc-viewer>
          </div>
          <div class="preview-document-status {{ dialogData.bill?.status }}">
            <svg xmlns="http://www.w3.org/2000/svg" width="90.001" height="90.048" viewBox="0 0 90.001 90.048">
              <g id="Group_37809" data-name="Group 37809" transform="translate(-617 -215.001)">
                <g id="pngfind.com-corner-ribbon-png-2775351" transform="translate(617.002 215.002)">
                  <path class="svg-plate" d="M0,85.478V44.825L27.669,16.95a41.747,41.747,0,0,0,3.122,3.521Q37.706,27.429,44.61,34.4q1.577,1.587,3.207,3.131C7.719,77.844,4.479,81.134.284,85.394a.343.343,0,0,1-.209.107A.129.129,0,0,1,0,85.478ZM44.611,34.4Q37.7,27.429,30.792,20.471a41.6,41.6,0,0,1-3.123-3.521l9.8-9.868a33.219,33.219,0,0,0,2.938,3.4c5.706,5.755,11.426,11.5,17.094,17.3l-9.681,9.751Q46.188,35.983,44.611,34.4ZM40.4,10.48a33.219,33.219,0,0,1-2.938-3.4L44.5,0H55.926c.454.435.956.857,1.377,1.281L68.157,12.224q.73.737,2.31,2.485L57.5,27.776C51.832,21.978,46.111,16.235,40.4,10.48Zm27.752,1.745L57.3,1.281C56.882.857,56.381.435,55.927,0H84.933c.007.024.03.037.067.043L77.213,7.9,70.468,14.71Q68.887,12.962,68.157,12.224Z" transform="translate(-0.002 -0.001)" fill="#1252af"/>
                  <path class="svg-corner" data-name="Path 35606" d="M5.365.214.39,5.2l9.97,0a.029.029,0,0,0,.021-.049Q7.919,2.693,5.465.237a.091.091,0,0,0-.1-.024Z" transform="translate(79.609 -0.166)" fill="#09316c"/>
                  <path class="svg-corner" data-name="Union 141" d="M4.465,9.041.881,5.432h0l-.828-.84A.119.119,0,0,1,.02,4.521.175.175,0,0,0,0,4.457V4.413c.041.028.095.012.162-.048C2.6,1.94,4.428.034,4.5,0l0,5.354q-.87-.024-2.027-.024,1.157,0,2.026.024V9.026a.021.021,0,0,1-.013.022H4.481A.02.02,0,0,1,4.465,9.041ZM1.672,5.333Z" transform="translate(0 80.998)" fill="#09316c"/>
                </g>
                <text id="Open" transform="translate(651.091 251.299) rotate(-45)" fill="#fff" font-size="12" font-family="Inter-Medium, Inter" font-weight="500" letter-spacing="0.004em"><tspan x="-15.492" y="0">{{ dialogData.bill?.status !== 'awaiting_payment' ? dialogData.bill?.status : 'Open' }}</tspan></text>
              </g>
            </svg>
          </div>
        </div>
      </div>
      <div class="input-wrapper">
        <div class="input-container" [ngClass]="{ 'invalid-validation': !dateHash }">
          <label>{{ 'bill.shareInvoice.dateRemove' | translate }}<span class="required-validation">*</span></label>
          <ejs-datepicker
            #datePickerHash
            [(ngModel)]="dateHash"
            [ngModelOptions]="{ standalone: true }"
            [min]="minDate"
            [locale]="locale$ | async"
            [format]="dateFormat"
            [placeholder]="'common.select' | translate"
            (keypress)="changeDate()"
            (change)="changeDate()"
          >
          </ejs-datepicker>
        </div>
        <div class="input-container">
          <label>{{ 'bill.shareInvoice.invoiceLink' | translate }}</label>
          <div class="text-select-field">
            <input
              id="link-Node"
              class="left-item"
              placeholder="Сгенеруйте посилання"
              [(ngModel)]="linkFile"
              [ngModelOptions]="{ standalone: true }"
              #sharableLink
            />
            <div class="right-item right-text" (click)="copyLink(sharableLink)">
              <i class="j-icon-copy-text" [ngClass]="{ active: linkFile }"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="button-container">
      <p>{{ 'bill.shareInvoice.descLine' | translate }}</p>
      <button *ngIf="!linkFile" class="btn-template btn-blue dropdown-button" (click)="generateHash($event)">
        {{ 'bill.shareInvoice.generate' | translate }}
      </button>
      <button *ngIf="linkFile" class="btn-template btn-blue dropdown-button" (click)="copyLink(sharableLink)">
        {{ 'bill.shareInvoice.copy' | translate }}
      </button>
    </div>
  </div>
</div>
